export const userInitials = (firstName, lastName) => {
    if (!firstName || !lastName) return ""
    const placeholder = firstName?.split('')[0] + "" +  lastName?.split('')[0]
    return placeholder;
}